import {IToJson} from '@toolify/client/src/types/IToJson'
import {
  IDatabaseViewResponseInstance,
} from '@toolify/server/src/controllers/DatabaseViewController/types/IDatabaseViewResponseInstance'

export function mapDatabaseViewResponseInstance(databaseView: IToJson<IDatabaseViewResponseInstance>): IDatabaseViewResponseInstance {
  return {
    ...databaseView,
    createdAt: new Date(databaseView.createdAt),
    updatedAt: new Date(databaseView.updatedAt),
  }
}
